import carta from "./Images/Carta.png";
import uwBlueprint from "./Images/uwblueprint.png";
import shoplogix from "./Images/shoplogix.jpg";
import mcap from "./Images/mcap.jpg";

export const cardContents = [
  {
    header: carta,
    title: "Carta (May 2022 - April 2023)",
    details: `Carta is a Unicorn startup that has made a name for itself as the world's leading Cap Table management software. 
    I have had the opportunity to spend 2 of my internships at this company as a Software Engineering Intern. 
    Here I have been able to be part of 2 teams. First, I was on the Employee Platform team where I was able to overhaul 
    the onboarding process for employees signing up for Carta to manage stocks issued to them from their companies. The 
    second time, I worked on the Total Compensation team, where we used the equity and salary info provided by the 30,000+ 
    corporations that are currently within the Carta ecosystem to develop data driven models that benchmark what compensation 
    a new or existing hire should be receiving. Specifically during my time here, I played a large role in expanding their 
    international outreach by providing an in-house currency conversion solution to convert any foreign currencies to USD.`, 
  },
  {
    header: uwBlueprint,
    title: "UW Blueprint (September 2021 - August 2022)",
    details: `UW Blueprint is a club within the University of Waterloo that provides software to NPOs pro-bono. 
    In my time here, I worked with 2 main non-profits. The first was named "HeadsUpGuys", which geared itself towards 
    educating and helping men going through depression. During my time working with them, I created a no-code development 
    toolkit that allowed the non-technical volunteers to build interactive content for its users, helping them keep user 
    engagement. The next NPO I worked with was named "Focus On Nature", which built many camp programs for youngsters looking 
    to explore the great outdoors. Here, I built a payments transaction portal, which allowed interested parents to register 
    their child for programs and pay money through the website. If a program was filled, they would be put onto a waitlist and 
    notified at a later date. This was a really fun time!`, 
  },
  {
    header: shoplogix,
    title: "Shoplogix (September 2021 - December 2021)",
    details: `Shoplogix is an IIoT (Industrial Internet of Things) company. They have sensors in manufacturing plants which send back signals 
    to their application to be analyzed and displayed on large screens within the plant itself. These screens would show analytics 
    such as the production rate of the factory, how much waste is being made, etc. Here, I got the chance to refactor their analytics 
    scheduling system by moving their data from XML to normalized PostgreSQL tables via C#.`,
  },
  {
    header: mcap,
    title: "MCAP (January 2021 - April 2021)",
    details: `MCAP is the largest mortgage financing firm in Canada. Here I had the opportunity to be a part of their new venture 
    to split their mortgage underwriting platform into a microservice architecture. I built an email service and several underwriting 
    calculators using this distributed system architecture. This was my first real tech job and it was an amazing experience learning 
    how distributed systems were made and the process through which CICD was done.`, 
  },
];
